import * as fb from 'firebase/app';
import 'firebase/auth';

// config firebase
fb.initializeApp({
  apiKey: 'AIzaSyA2x_S5a3SVwCVsfXKN-sTba2osRGDZXU0',
  authDomain: 'authentication-project-c8e29.firebaseapp.com',
  databaseURL: 'https://authentication-project-c8e29.firebaseio.com',
  projectId: 'authentication-project-c8e29',
  storageBucket: 'authentication-project-c8e29.appspot.com',
  messagingSenderId: '1067385450602',
  appId: '1:1067385450602:web:b765f385c80558b2'
});

export const firebase = fb;
